import { render, staticRenderFns } from "./LoanProduct.vue?vue&type=template&id=2191344f"
import script from "./LoanProduct.vue?vue&type=script&lang=js"
export * from "./LoanProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports